import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UiService {

  constructor() { }

  getPixelRatio(px: number) {
    // console.log(window.devicePixelRatio);
    return px * (window.innerWidth / 3840);
  }

  cssVar(params: {
    root?: any;
    value: any;
    property: string;
    cssPrefix?: string;
  }): void {
    params = Object.assign({
      value: '',
      cssPrefix: 'app',
      property: 'css-var',
      root: document.getElementsByTagName('html')[0],
    }, params);

    if (params.value === undefined || params.value === null) {
      return;
    }

    setTimeout(() => {
      if (params.root.length > 0) {
        params.root[0].style.setProperty(`--${params.cssPrefix}-${params.property}`, `${params.value}`);
      } else {
        params.root.style.setProperty(`--${params.cssPrefix}-${params.property}`, `${params.value}`);
      }
    }, 0);
  }
}
